import { SummaryController } from './summary.controller';

export const SummaryComponent: ng.IComponentOptions = {
    template: require('./summary.html'),
    controller: SummaryController
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/app/sections/registration/summary/summary.component.ts